import React, { FC, useRef } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { Glyph } from '../../../../components';
import { Vector } from '../../../../types';

export type BouncingGlyphProps = {
  matrix: number[][];
  colors: string[];
  position: Vector;
  rotation: Vector;
};

export const BouncingGlyph: FC<BouncingGlyphProps> = ({
  matrix,
  colors,
  position,
  rotation,
}) => {
  const groupRef = useRef<any>();
  const { clock } = useThree();
  useFrame(() => {
    if (groupRef.current) {
      groupRef.current.position.z =
        position[2] + Math.sin(clock.elapsedTime * 5) * 0.1;
    }
  });

  return (
    <group ref={groupRef} position={position} rotation={rotation}>
      <Glyph matrix={matrix} colors={colors} />
    </group>
  );
};
